export class GroupedByFilterResult {
   Id: string;
   Total: number;
   Name: string;
}